<template>
  <div class="page page-full user-list-page">
    <div class="page-header with-actions">
      <h1>Users</h1>
      <div class="actions">
        <b-btn @click="createAdmin" variant="success">
          Add New Admin
        </b-btn>
      </div>
    </div>
    <dt-filters-group :tableId="tableId">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3">
          <v-form-group :staticLabel="true" icon="magnifier" label="Search">
            <dt-filter-input id="search-filter" />
          </v-form-group>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <v-form-group :staticLabel="true" label="ID">
            <dt-filter-input id="id-filter" column-name="Id" placeholder="ID" />
          </v-form-group>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <v-form-group :staticLabel="true" label="Enabled">
            <dt-filter-select
              id="enabled-filter"
              column-name="Disabled"
              :options="enabledFilterOptions"
              :add-empty="true"
            />
          </v-form-group>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <v-form-group :staticLabel="true" label="Role">
            <dt-filter-select
              id="role-filter"
              column-name="Role"
              :options="roleFilterOptions"
              :add-empty="true"
            />
          </v-form-group>
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <v-form-group :staticLabel="true" icon="calendar" label="Creation Date">
            <dt-filter-daterange column-name="CreationDate" placeholder="Creation Date" />
          </v-form-group>
        </div>
      </div>
    </dt-filters-group>
    <dt-datatable
      ref="userList"
      :id="tableId"
      url="/admin/usersList"
      :columns="columns"
      :dt-options="dtOptions"
      @selection-changed="onSelectionChanged"
    >
      <template #disabled="{ data }">
        <span v-if="data.disabled" class="badge badge-danger">No</span>
        <span v-else class="badge badge-success">Yes</span>
      </template>
      <template #actions="{ data: user }">
        <div class="td-links-wrap">
          <a class="btn btn-link p-0" :class="{'text-danger': !user.disabled, 'text-success': user.disabled}" @click="disableUser(user)">
            {{ user.disabled ? 'Enable' : 'Disable' }}
          </a>
          <a v-if="user.id !== userId && !user.disabled && user.email" class="btn btn-link pl-3" @click="loginAs(user)">
            Login As
          </a>
          <a v-if="!user.emailConfirmed && user.role === 'Patient'" class="btn btn-link pl-3" @click="resendEmail(user)">
            Resend Email
          </a>
        </div>
      </template>
    </dt-datatable>
    <create-admin-modal ref="createAdminModal" @success="adminCreated"></create-admin-modal>
  </div>
</template>

<script>
import adminService from "services/admin-service";
import userService from "services/user-service";
import CreateAdminModal from "./create-admin-modal";

import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('user');

export default {
  components: {
      CreateAdminModal
  },

  data() {
    return {
      tableId: `user-list-id${this.$auth.id}`,
      enabledFilterOptions: [
        { text: "Yes", value: false },
        { text: "No", value: true }
      ],
      roleFilterOptions: [],
      columns: [
        "Id",
        "Email",
        "FirstName",
        "LastName",
        { name: "Role", sortable: false },
        { name: "Disabled", title: "Enabled" },
        "CreationDate",
        { name: "Actions", data: false }
      ],
      dtOptions: {
        order: [[1, "asc"]],
        columnDefs: [
          { width: "30px", targets: 0 },
          { width: "15%", targets: 2 }
        ]
      }
    };
  },

  methods: {
    ...mapActions(['loginAsUser']),

    createAdmin() {
      this.$refs.createAdminModal.show();
    },

    async disableUser(data) {
      await userService.disable(data.id);

      this.redrawTable();

      this.$root.successToast(`User ${data.disabled ? "enabled" : "disabled"}.`);
    },

    adminCreated() {
      this.redrawTable();

      this.$root.successToast("Admin created.");
    },

    onSelectionChanged(val) {
      this.selected = val;
    },

    redrawTable() {
      this.$refs.userList.draw();
    },

    async loginAs(user) {
      await this.loginAsUser({
        user: user
      });
    },

    async resendEmail(user) {
      try {
        await userService.resendInvitation(user.id);

        this.$root.successToast("Invitation email sent");
      }
      catch (error) {
        this.$root.errorToast(error.message);
      }
    }
  },

  computed: {
    userId() {
      return parseInt(this.$auth.user.sub);
    }
  },

  async created() {
    this.roleFilterOptions = await adminService.getRoles();
  }
};
</script>